import { useState, useRef, useEffect } from 'react'
import api from '../services/api'

interface Finalidade {
  fic_cod: number
  fic_des: string
}

interface Props {
  value: string
  onChange: (cod: string, des: string) => void
}

export default function FinalidadeCompraSelect({ value, onChange }: Props) {
  const [aberta, setAberta] = useState(false)
  const [filtro, setFiltro] = useState('')
  const [lista, setLista] = useState<Finalidade[]>([])
  const [localCod, setLocalCod] = useState(value)
  const [aviso, setAviso] = useState('')
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => { setLocalCod(value); if (value) setAviso('') }, [value])

  useEffect(() => {
    api.get('/erp/comfin').then(r => setLista(r.data)).catch(() => setLista([]))
  }, [])

  useEffect(() => {
    function handler(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setAberta(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  const selecionada = lista.find(f => String(f.fic_cod) === value)

  const filtrada = lista.filter(f => {
    if (!filtro) return true
    const t = filtro.toLowerCase()
    return String(f.fic_cod).includes(t) || f.fic_des.toLowerCase().includes(t)
  })

  function selecionar(f: Finalidade) {
    onChange(String(f.fic_cod), f.fic_des)
    setLocalCod(String(f.fic_cod))
    setAviso('')
    setAberta(false)
    setFiltro('')
  }

  function handleCodBlur() {
    if (!localCod) { onChange('', ''); setAviso(''); return }
    const encontrada = lista.find(f => String(f.fic_cod) === localCod)
    if (encontrada) {
      onChange(localCod, encontrada.fic_des)
      setAviso('')
      setAberta(false)
    } else {
      onChange('', '')
      setAviso(`Código "${localCod}" não encontrado`)
    }
  }

  return (
    <div className="nat-wrap" ref={ref}>
      <div className="nat-input-row">
        <input
          className="nat-cod-input"
          type="text"
          placeholder="Cód."
          value={localCod}
          style={aviso ? { borderColor: '#dc2626' } : undefined}
          onChange={e => { setLocalCod(e.target.value.replace(/\D/g, '')); setAviso('') }}
          onBlur={handleCodBlur}
          onKeyDown={e => { if (e.key === 'Enter') handleCodBlur() }}
        />
        <div className="nat-desc-box" onClick={() => setAberta(o => !o)}>
          {selecionada
            ? <span className="nat-dsc">{selecionada.fic_des}</span>
            : <span className="nat-placeholder">Selecione ou digite o código...</span>
          }
          <span className="nat-chevron">{aberta ? '▴' : '▾'}</span>
        </div>
      </div>
      {aviso && <div style={{ fontSize: '0.75rem', color: '#dc2626', marginTop: '0.2rem', paddingLeft: '0.25rem' }}>{aviso}</div>}

      {aberta && (
        <div className="nat-lista">
          <div className="nat-filtro-wrap">
            <input
              autoFocus
              className="nat-filtro"
              placeholder="Buscar por código ou descrição..."
              value={filtro}
              onChange={e => setFiltro(e.target.value)}
            />
          </div>
          <div className="nat-itens">
            {filtrada.length === 0 && <div className="nat-vazio">Nenhum resultado</div>}
            {filtrada.map(f => (
              <button
                key={f.fic_cod}
                className={`nat-item${String(f.fic_cod) === value ? ' nat-item--ativo' : ''}`}
                onClick={() => selecionar(f)}
              >
                <div className="nat-item-linha1">
                  <span className="nat-item-cod">#{f.fic_cod}</span>
                </div>
                <div className="nat-item-dsc">{f.fic_des}</div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
